import { Typography } from "@/components/ui/typography"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"

/** The article fields as the master-data detail panel shows them, with the
 *  org's own name for "product group". */
export function ArticleFieldsPreview({
  productGroupLabel,
}: {
  productGroupLabel: string
}) {
  const { translate } = useTranslation()
  const rows: { label: string; value: string }[] = [
    { label: translate("MC_MD_PANEL_COL_ARTICLE"), value: "10432-A" },
    {
      label: translate("MC_MD_PANEL_COL_DESCRIPTION"),
      value: translate("MC_TPL_MD_PREVIEW_ARTICLE_NAME"),
    },
    {
      label: productGroupLabel.trim() || translate("MC_MD_FIELD_PRODUCT_GROUP"),
      value: translate("MC_TPL_MD_PREVIEW_GROUP_VALUE"),
    },
  ]
  return (
    <div data-testid="master-data-preview" className="rounded-md border p-4">
      <dl className="grid grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] gap-x-4 gap-y-2.5">
        {rows.map((row) => (
          <div key={row.label} className="contents">
            <dt className="min-w-0">
              <Typography as="muted" className="truncate">
                {row.label}
              </Typography>
            </dt>
            <dd>
              <Typography as="small">{row.value}</Typography>
            </dd>
          </div>
        ))}
      </dl>
    </div>
  )
}
